export enum AlertStatusEnum {
  UnifiedResolution = "unifiedResolution",
  Divergence = "divergence",
}
